import { ROLES } from '@/shared/constants/roles';
import { AI_PACKAGE_FEATURE_KEYS, AI_PACKAGE_FLAGS } from '@/shared/constants/packageFeatures';

export const insightsRoutes = [
  {
    path: 'insights',
    name: 'insights',
    component: () => import('./views/InsightsView.vue'),
    meta: {
      requiredRole: ROLES.ADVISOR,
      requiredFeature: AI_PACKAGE_FEATURE_KEYS.INSIGHTS_REPORTING,
      requiredFeatureFlag: AI_PACKAGE_FLAGS.aiInsightsDashboard,
    },
  },
];
